import React, {useRef, useState} from 'react';

import cs from 'classnames';

import {RenameListItem} from 'app/components/general/RenameListItem';
import {ActionsButton} from 'app/general/widgets/ActionsButton';
import {useUpdateLane} from 'app/lanes/api';
import {gt} from 'app/utils/i18n';

import {ConfirmLaneDeletePopover} from './ConfirmLaneDeletePopover';

import {LaneSerializedType} from 'sweet-types';

interface Props {
  lane: LaneSerializedType;
  borderBottom?: boolean;
}

export function ManageLanesItemList({
  lane,
  borderBottom = false,
}: Props): JSX.Element {
  const [isRenaming, setIsRenaming] = useState(false);
  const [isConfirmingDelete, setConfirminDelete] = useState(false);
  const actionsButtonRef = useRef<HTMLDivElement | null>(null);
  const [updateLane] = useUpdateLane();

  return (
    <div
      className={cs(
        'row border-top d-flex align-items-center',
        isRenaming ? 'py-1' : 'py-2',
        {'border-bottom': borderBottom}
      )}
    >
      <div className="col-auto pl-1 pr-0 text-dark font-weight-bold">
        <i className="fas fa-road fa-fw" />
      </div>
      <div
        className={cs('col text-truncate text-dark font-weight-bold pr-0', {
          'pl-0': isRenaming,
        })}
      >
        {!isRenaming ? (
          lane.name
        ) : (
          <RenameListItem
            initialValue={lane.name}
            onSave={(name) =>
              updateLane({hashid: lane.hashid, name})
                .unwrap()
                .then(() => setIsRenaming(false))
            }
            onCancel={() => setIsRenaming(false)}
          />
        )}
      </div>
      <div className="col-auto pr-0 pl-2">
        <ActionsButton
          ref={actionsButtonRef}
          actions={[
            {
              text: gt('Rename'),
              icon: 'fa fa-pen',
              key: 'rename',
              callback: () => setIsRenaming(true),
            },
            {
              text: gt('Move to Recycle Bin'),
              icon: 'far fa-trash',
              key: 'trash',
              callback: () => setConfirminDelete(true),
            },
          ]}
        />
        {isConfirmingDelete && actionsButtonRef.current != null ? (
          <ConfirmLaneDeletePopover
            isOpen={isConfirmingDelete}
            toggle={() => setConfirminDelete(false)}
            target={actionsButtonRef.current}
            laneHashid={lane.hashid}
          />
        ) : null}
      </div>
    </div>
  );
}
